import React from 'react'
import Leaderboard from './Leaderboard';

const Modal = ({type, header, realleaderboard}) => {

  let MockLeaderBoard = [
    {
      displayName: "Nabil",
      highScore: 234
    },
    {
      displayName: "Anas",
      highScore: 234
    },
    {
      displayName: "Fuufu",
      highScore: 234
    },
    {
      displayName: "Burhy",
      highScore: 234
    },
    {
      displayName: "Rdnix",
      highScore: 234
    },
    {
      displayName: "tsb",
      highScore: 234
    },
    {
      displayName: "Nabil",
      highScore: 234
    },
    {
      displayName: "Nabil",
      highScore: 234
    }
  ]

  

let modal = document.getElementById("Leaderboard");

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
  return (
    <div>
      <div id="Leaderboard" class="modal" style={{textShadow:'0px 0px 10px black'}}>
        <div class="modal-content">
          <div class="modal-header" style={{textTransform:'Uppercase', fontSize:'15px'}}>
            <h2 style={{fontSize:'50px'}}>{header}</h2>
          </div>
          <div class="modal-body">
            <Leaderboard leaderbaord={realleaderboard} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
